import { render, staticRenderFns } from "./bao.vue?vue&type=template&id=1234dca2&scoped=true&"
import script from "./bao.vue?vue&type=script&lang=js&"
export * from "./bao.vue?vue&type=script&lang=js&"
import style0 from "./bao.vue?vue&type=style&index=0&id=1234dca2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1234dca2",
  null
  
)

export default component.exports